import {PanelGroup, Section, SectionRun} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/PanelState';

export class LayoutTraversal
{
    public static traverseSections(run:SectionRun, onVisit:(Section) => (void))
    {
        const sections = run.sections;

        if( !sections || sections.length === 0 )
            return;

        for( let section of sections )
            onVisit(section);

        sections.map((section:Section) =>
        {
            const content = section.content;

            if( content instanceof SectionRun )
                this.traverseSections((content as SectionRun), onVisit);
        });
    }

    public static traverseSectionRuns(run:SectionRun, onVisit:(SectionRun) => (void))
    {
        onVisit(run);

        const sections = run.sections;
        if( !sections || sections.length === 0 )
            return;

        sections.map((section:Section) =>
        {
            const content = section.content;

            if( content instanceof SectionRun )
                this.traverseSections((content as SectionRun), onVisit);
        });
    }

    public static traversePanelGroups(run:SectionRun, onVisit:(PanelGroup) => (void)):void
    {
        const sections = run.sections;

        if( !sections || sections.length === 0 )
            return;

        sections.map((section:Section) =>
        {
            const content = section.content;

            if( content instanceof SectionRun )
                this.traversePanelGroups((content as SectionRun), onVisit);
            else if( content instanceof PanelGroup )
            {
                let panelGroup = (content as PanelGroup);
                onVisit(panelGroup);
            }
        });
    }

    public static traversePanels(run:SectionRun, onVisit:(Panel) => (void)):void
    {
        LayoutTraversal.traversePanelGroups(run, (group:PanelGroup) =>
        {
            const panels = group.panels;
            for( let panel of panels )
                onVisit(panel);
        });
    }
}
